export default "__VITE_ASSET__BgHFUwhS__"